/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {DictionaryItem} from '../models/DictionaryItem';
import type {Error} from '../models/Error';

export interface GetLicenseCrmModules$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getLicenseCrmModulesRequest = createAction<PayloadData<void>>('GET_LICENSE_CRM_MODULES__GET_LICENSE_CRM_MODULES__REQUEST');
export const getLicenseCrmModulesSuccess = createAction<PayloadData<Array<DictionaryItem>>>('GET_LICENSE_CRM_MODULES__GET_LICENSE_CRM_MODULES__SUCCESS');
export const getLicenseCrmModulesFailure = createAction<PayloadData<Error, void, true>>('GET_LICENSE_CRM_MODULES__GET_LICENSE_CRM_MODULES__FAILURE');

export const getLicenseCrmModulesActions = [
    getLicenseCrmModulesRequest,
    getLicenseCrmModulesSuccess,
    getLicenseCrmModulesFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getLicenseCrmModules = (config?: GetLicenseCrmModules$Config) => {
    return {
        CALL_API: {
            types: getLicenseCrmModulesActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/dictionaries/license-crm-modules`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

